import BaseAPI, { recoverFromNotFound, ROUTES, VERSIONS } from './BaseAPI'

const { VERSION_TWO } = VERSIONS
const { ESCALATION } = ROUTES

export default class EscalationsAPI extends BaseAPI {
  @recoverFromNotFound()
  async escalateMessage(messageId: string) {
    const { version=VERSION_TWO } = super.getVersion(ESCALATION)
    const res = await this.httpClient.post('/:version/message/:messageId/escalation', {
      urlParams: {
        version,
        messageId
      }
    })

    return res.data
  }

  @recoverFromNotFound()
  async acknowledge(escalationId: string, {
    messageId,
    userTokens,
  }: {
    messageId: string,
    userTokens: Array<string>,
  }) {
    const { version=VERSION_TWO } = super.getVersion(ESCALATION)
    const res = await this.httpClient.post('/:version/message/:messageId/escalation/:escalationId/confirm', {
      urlParams: {
        version,
        escalationId,
        messageId,
      },
      data: {
        confirm_as: userTokens,
      },
    })

    return res.data
  }

  @recoverFromNotFound()
  async cancel(messageId: string) {
    const { version=VERSION_TWO } = super.getVersion(ESCALATION)
    await this.httpClient.del('/:version/message/:messageId/escalation', {
      urlParams: {
        version,
        messageId
      }
    })
  }

  @recoverFromNotFound()
  async skip(escalationId: string, {
    messageId,
    userTokens,
  }: {
    messageId: string,
    userTokens: Array<string>,
  }) {
    const { version=VERSION_TWO } = super.getVersion(ESCALATION)
    const res = await this.httpClient.post('/:version/message/:messageId/escalation/:escalationId/skip', {
      urlParams: {
        version,
        escalationId,
        messageId,
      },
      data: {
        skip_as: userTokens,
      },
    })

    return res.data
  }
}
